import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { FieldProps, useFieldHelper } from 'framework/ui/field';

const NonCompliantReasonsField = ({ source }: FieldProps<string[]>) => {
  const { getValue } = useFieldHelper<string[]>({ source });
  const reasons = getValue() || [];

  return (
    <Stack>
      <Typography variant="body1" color="error">
        {reasons[0] || ''}
      </Typography>
      {reasons.length > 1 && (
        <Typography variant="caption" color="error">{`...and ${reasons.length - 1} more`}</Typography>
      )}
    </Stack>
  );
};

export default NonCompliantReasonsField;
